import React, { useEffect, useState } from "react";
import { AppLayout } from "@amzn/awsui-components-console";

import { useFeatureFlag } from "src/api/featureFlags";
import { PAGE_TITLES } from "src/app/constants";
import ConfigDrivenClaimsHistory from "src/claimsHistory/ConfigDrivenClaimsHistory";
import LoadingIndicator from "src/components/loadingIndicator/LoadingIndicator";
import SideMenu from "src/components/sideMenu/SideMenu";
import WorkersCompensationClaimsHistory from "src/components/workersCompensationClaimsHistory/WorkersCompensationClaimsHistory";

const MySubmittedClaimsPage = () => {
  const [navigationOpen, setNavigationOpen] = useState(false);
  const { value: configDriven, isLoading } = useFeatureFlag("enableConfigDrivenClaimsHistory");

  /**
   * Changes the browser tab/menu bar title to My Submitted Claims when page loads
   */
  useEffect(() => {
    document.title = PAGE_TITLES.MY_SUBMITTED_CLAIMS;
  }, []);

  /**
   * The same boundary the claims history page draws, in the one mode this route
   * presents. A resolved false and a failed lookup both render the legacy
   * component, which keeps an unavailable flag from costing the user the page.
   */
  const content = (): React.ReactNode => {
    if (isLoading) {
      return (
        <LoadingIndicator label="Loading claims history" testId="claims-history-flag-loading" />
      );
    }
    return configDriven ? (
      <ConfigDrivenClaimsHistory mySubmittedClaims={true} />
    ) : (
      <WorkersCompensationClaimsHistory showUserClaimsOnly={true} />
    );
  };

  return (
    <AppLayout
      content={content()}
      navigation={<SideMenu />}
      navigationOpen={navigationOpen}
      onNavigationChange={({ detail }) => setNavigationOpen(detail.open)}
      toolsHide={true}
      ariaLabels={{
        navigationClose: "Close side menu",
        navigationToggle: "Open Side menu",
      }}
      contentType="table"
      footerSelector="#app-footer"
      headerSelector="#app-header"
    />
  );
};
export default MySubmittedClaimsPage;
